import rill from "rill";
import set from "@rill/set";

import controller from "./plan-manager.controller";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";

const PlanManager = (app) => {
  app.at(
    "/plan-manager/*",
    rill()
      .use(set("heading", ["Coaching", "Plan Manager"]))
      .setup((app) => {
        app.get(
          "/",
          (ctx, next) =>
            checkOrganizationSectionPermission(
              ctx,
              next,
              ["PRESS", "PUSH"],
              "/coaching-portal/athletes",
              ["Admin", "Owner"]
            ),
          controller
        );
      })
  );
};

export default PlanManager;
